export const GET_MEMBERS = 'GET_MEMBERS'
export const GET_STAFFS = 'GET_STAFFS'
export const GET_ADMINS = 'GET_ADMINS'
export const GET_MEMBER = 'GET_MEMBER'
export const GET_STAFF = 'GET_STAFF'
export const GET_ADMIN = 'GET_ADMIN'
export const GET_AVATAR = 'GET_AVATAR'
export const GET_PROFILE = 'GET_PROFILE'
